import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Checkbox,
  Button,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState } from "react";
import { colors, sizes } from "../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import TransferList from "./TransferList";
import BasicModal from "./BasicModal";
import {
  getCustomers,
  getRelshipLevel,
  setCGState,
} from "./customerGroupSetupSlice";
import { useEffect } from "react";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function SelectCustomer() {
  const [value, setValue] = useState();
  const cgState = useSelector((store) => store.customerGroupSetup);
  const dispatch = useDispatch();
  const {
    countryID,
    customerTypeCode,
    customerLevels,
    customerLevel,
    customerLevelID,
    relShipLevels,
    relShipLevel,
    relShipLevelID,
    customerName,
    activeCustomer,
    newCustomer,
    customers,
    selCustomers,
  } = cgState;

  useEffect(() => {
    if (relShipLevels.length <= 0) {
      dispatch(getRelshipLevel());
    }
  }, []);

  function updateCustomerLevel(event) {
    const level = event.target.value;
    const levelId = customerLevels.find(
      (item) => item.customerLevel === level
    ).customerLevelID;
    dispatch(setCGState("customerLevel", level));
    dispatch(setCGState("customerLevelID", levelId));
    dispatch(setCGState("customers", []));
    dispatch(setCGState("selCustomers", []));
  }

  function updateRelshipLevel(event) {
    const relship = event.target.value;
    let id = "";
    if (relship === "All") {
      id = 0;
    } else {
      id = relShipLevels.find(
        (item) => item.trustDesc === relship
      ).trustLevelID;
    }
    dispatch(setCGState("relShipLevel", relship));
    dispatch(setCGState("relShipLevelID", id));
  }

  function updateCustomerName(event) {
    const name = event.target.value;
    dispatch(setCGState("customerName", name));
  }

  function setChecked(event, stateName) {
    const check = event.target.checked;
    dispatch(setCGState(stateName, check));
  }

  function searchCustomer() {
    dispatch(
      getCustomers({
        countryID,
        customerTypeCode,
        customerLevelID,
        customerName,
        activeCustomer,
        relShipLevelID,
        newCustomer,
      })
    );
  }

  return (
    <Box>
      <CollapseSection title="Search Customers">
      <Box
        sx={{ mt: 3, }}
      >
        <Grid container spacing={2}>
            <Grid item xs={12} lg={2.25}>
              <Box sx={{ mt: 1, ml:-1}}>
                <Grid container justifyContent="flex-end" spacing={2} pb={1} >
                  <Grid item xs={12} md={5.4} lg={11.5}>
                  <FormControl>
                    <InputLabel>Level</InputLabel>
                    <Select
                      value={customerLevel}
                      label="Level"
                      sx={{
                        height: sizes.h35,
                        width: sizes.w300,
                        color: colors.black,
                        mt: 1,
                      }}
                      onChange={updateCustomerLevel}
                    >
                      {customerLevels.map((level, index) => {
                        return (
                          <MenuItem key={index} value={level.customerLevel}>
                            {level.customerLevel}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  </Grid>

                  <Grid item xs={12}  md={5.4} lg={11.5}>
                    <Box>
                            <FormControl>
                              <InputLabel>Relationship Level</InputLabel>
                              <Select
                                value={relShipLevel}
                                label="Relationship Level"
                                sx={{
                                  height: sizes.h35,
                                  width: sizes.w300,
                                  color: colors.black,
                                  mt: 1,
                                }}
                                onChange={updateRelshipLevel}
                              >
                                <MenuItem value={"All"}>All</MenuItem>
                                {relShipLevels.map((item, index) => {
                                  return (
                                    <MenuItem key={index} value={item.trustDesc}>
                                      {item.trustDesc}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                           </FormControl>
                    </Box>
					       </Grid>

                  <Grid item xs={12} md={5.4} lg={11.5}>
                    <TextField
                      label="Customer Name"                     
                      sx={{
                        color: colors.black,                               
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      value={customerName}
                      onChange={updateCustomerName}
                      autoComplete="editpage-customer-name"
                      InputProps={{ autoComplete: "editpage-customer-name" }}
                      name="editpage-customer-name"
                    />
                  </Grid>
               

                  <Grid container direction="column" sx={{marginTop:2,marginLeft:4.5}}>
                    <Grid item sm={2} md={1.5}  sx={{marginBottom:1}}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={activeCustomer}
                              onChange={(event) => {
                                console.log(event.target.checked);
                                setChecked(event, "activeCustomer");
                              }}
                              InputProps={{ "aria-label": "controlled" }}
                              sx={{
                                padding:0,margin:0,
                              }}
                            />
                          }
                        />
                        <Typography sx={{ margin:0,padding:0 }}>
                          Active Customers Only
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item  sm={2} md={1.5} sx={{marginBottom:1}}  >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={newCustomer}
                              onChange={(event) =>
                                setChecked(event, "newCustomer")
                              }
                              InputProps={{ "aria-label": "controlled" }}
                              sx={{
                                padding:0,margin:0,
                              }}
                            />
                          }
                        />
                        <Typography sx={{ padding:0,margin:0 }}>
                          New Customers Only
                        </Typography>
                      </Box>
                    </Grid>
					        </Grid>

                  <Grid item  xs={12} md={5.4} lg={11.5} sx={{ml:26}}>
                  <Button
                    startIcon={<SearchIcon />}
                    sx={{
                      bgcolor: "darkred.light",
                      color: colors.white,
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: "darkred.main",
                        color: colors.white,
                      },
                      mt:1,
                      
                    }}
                    onClick={searchCustomer}
                  >
                    Search
                  </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} lg={9.75}>
              <Box sx={{
              mt:1,
              p:4,
              ml:1,
              mr:-2,
              borderLeft:1,
              borderColor:"#c6c6c6",
            }}>
              <TransferList
                leftList={customers}
                rightList={selCustomers}
                leftState={"customers"}
                rightState={"selCustomers"}
                /> 
              <Box sx={{mr:-0.85}}><BasicModal /></Box>
             </Box>
			      </Grid>
        </Grid>
      </Box>
      </CollapseSection>
    </Box>
  );
}
